var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"secondary","outlined":"","rounded":"","small":""},on:{"click":function($event){return _vm.download()}}},[_c('span',[_vm._v("PDF")]),_c('v-icon',{attrs:{"right":"","small":""}},[_vm._v("mdi-printer")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }